import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import AvailabilityDetailActions from '../actions/AvailabilityDetailActions';
import GroupSearchFeedbackActions from '../actions/GroupSearchFeedbackActions';
import { getActiveHoldsByMetadataId } from '../selectors/HoldsSelector';
import { currentUserSelector } from '../selectors/AuthSelector';
import { currentSiteScopes } from '../selectors/ScopeSelector';
import { getShelvesForCurrentUser } from '../selectors/ShelfSelector';
import ManifestationListItem from '../components/search/ManifestationListItem';
import { itemTransactionConstants, itemTransactionStatus } from '@bibliocommons/utils-item';
import { currentLibrarySelector } from '../selectors/LibrarySelector';
import { getCheckoutsByMetadataId } from '../selectors/CheckoutSelector';

export class ManifestationListItemContainer extends BcReactComponent {
  render() {
    const {
      hold,
      materialType,
      hasItemLevelHoldableItems,
      checkout,
      shelfItem,
      availabilityDetail,
      availabilityDetailActions,
      groupSearchFeedbackActions,
      catalogSearchOptions,
      currentUser,
      item,
      drawerOpen,
      showGroupingDebug,
      searchScopeIsCurrent,
      showHoldCount } = this.props;

    const status = itemTransactionStatus(hold, materialType, hasItemLevelHoldableItems, checkout);
    let editable = false;

    if (([itemTransactionConstants.CANCEL_HOLD_BUTTON, itemTransactionConstants.DIGITAL_READING_LINKS].includes(status)) || shelfItem) {
      editable = true;
    }

    return (
      <ManifestationListItem
        availabilityDetail={availabilityDetail}
        availabilityDetailActions={availabilityDetailActions}
        groupSearchFeedbackActions={groupSearchFeedbackActions}
        catalogSearchOptions={catalogSearchOptions}
        currentUser={currentUser}
        item={item}
        drawerOpen={drawerOpen}
        editable={editable}
        showGroupingDebug={showGroupingDebug}
        searchScopeIsCurrent={searchScopeIsCurrent}
        showHoldCount={showHoldCount} />
    );
  }
}

ManifestationListItemContainer.propTypes = {
  materialType:               PropTypes.string,
  hasItemLevelHoldableItems:  PropTypes.bool,
  item:                       ImmutablePropTypes.map,
  shelfItem:                  ImmutablePropTypes.map,
  availabilityDetail:         ImmutablePropTypes.map,
  availabilityDetailActions:  PropTypes.objectOf(PropTypes.func).isRequired,
  groupSearchFeedbackActions: PropTypes.objectOf(PropTypes.func).isRequired,
  catalogSearchOptions:       ImmutablePropTypes.map,
  currentUser:                ImmutablePropTypes.map,
  drawerOpen:                 PropTypes.bool,
  checkout: ImmutablePropTypes.mapContains({
    id: PropTypes.string
  }),
  hold: ImmutablePropTypes.mapContains({
    id: PropTypes.string,
    status: PropTypes.string
  }),
  searchScopeIsCurrent: PropTypes.bool,
  showHoldCount: PropTypes.bool
};

ManifestationListItemContainer.displayName = 'ManifestationListItemContainer';

const mapStateToProps = (state, ownProps) => {
  const library = currentLibrarySelector(state);
  const itemId = ownProps.item.get('id');
  const currentUser = currentUserSelector(state);
  const shelfItem = getShelvesForCurrentUser(state).get(itemId);
  const holds = getActiveHoldsByMetadataId(state).get(itemId, Immutable.List());
  const checkouts = getCheckoutsByMetadataId(state).get(itemId, Immutable.List());
  const policy = state.getIn(['entities', 'bibs', itemId, 'policy'], Immutable.Map());
  const currentScopeId = currentSiteScopes(state).last().get('scopeId');
  const searchScopeIsCurrent = state.getIn(['search', 'catalogSearch', 'scope']) === currentScopeId;
  const showHoldCount = library.get('showHoldCountInSearch');

  return {
    shelfItem,
    hold:                       holds.size === 1 ? holds.first() : null,
    holdable:                   state.getIn(['entities', 'bibs', itemId, 'policy', 'holdable'], false),
    materialType:               state.getIn(['entities', 'bibs', itemId, 'policy', 'materialType']),
    hasItemLevelHoldableItems:  policy.get('itemLevelHoldableItems'),
    checkout:                   checkouts.first(),
    availabilityDetail:         state.get('availabilityDetail'),
    catalogSearchOptions:       state.getIn(['search', 'catalogSearchOptions']),
    currentUser,
    showGroupingDebug:          currentUser && currentUser.get('showGroupingDebug') && state.getIn(['search', 'catalogSearch', 'view']) === 'grouped',
    searchScopeIsCurrent,
    showHoldCount
  };
};

const mapDispatchToProps = dispatch => ({
  availabilityDetailActions: bindActionCreators(AvailabilityDetailActions, dispatch),
  groupSearchFeedbackActions: bindActionCreators(GroupSearchFeedbackActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ManifestationListItemContainer);



// WEBPACK FOOTER //
// ./app/containers/ManifestationListItemContainer.jsx